import { SurveyAnswer } from "./SurveyAnswer";

export class SurveyNumberAnswer extends SurveyAnswer {
    public constructor(
        public valueNumber: number
    ) {
        super();
    }
 }
